import Link from 'next/link'
import { useEffect, useRef } from 'react'
import { gsap, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from './ActiveEvent.module.scss'

gsap.registerPlugin(ScrollTrigger)

interface Event {
  id: number;
  title: {
    rendered: string;
  };
  thumbnail_img?: string;
  start_date?: string;
  end_date?: string;
  duration?: string;
  status01?: string;
  status01_color?: string;
  status02?: string;
  status02_color?: string;
}

interface Props {
  activeEvents: Event[];
  getEventDateDisplay: (event: Event) => string;
}

const tweenVars: gsap.TweenVars = {
  y: 50,
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
}

const ActiveEvent: React.FC<Props> = ({ activeEvents, getEventDateDisplay }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const itemsRef = useRef<HTMLDivElement[]>([])
  const titleRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    const elements = [titleRef.current, ...itemsRef.current]
    gsap.set(elements, { opacity: 0, y: 50 })

    const timeline = gsap.timeline()
    timeline.to(elements, {
      opacity: 1,
      y: 0,
      duration: 0.5,
      stagger: 0.3,
      ease: Power1.easeOut,
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: containerRef.current,
      start: 'top 80%',
      toggleActions: 'play none none reverse',
    })

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill())
      timeline.kill()
    }
  }, [activeEvents])

  return (
    <div className={styles.rightContents} ref={containerRef}>
      <h2 className={styles.rightContents_title} ref={titleRef}>開催予定のセミナー・イベント</h2>
      {activeEvents && activeEvents.length > 0 ? (
        activeEvents.map((event, index) => (
          <div
            key={event.id}
            ref={el => {
              if (el) {
                itemsRef.current[index] = el;
              }
            }}
            className={styles.rightContents_item}
          >
            <a href={`/events/${event.id}`}>
              <figure className={styles.rightContents_item_img}>
                <img src={event.thumbnail_img || '/images/img/img_thumbnail_dummy.png'} alt={event.title.rendered || 'デフォルト画像'} />
              </figure>
              <div className={styles.rightContents_item_text}>
                <div className={styles.rightContents_item_text_status}>
                  <span className={styles.rightContents_item_text_status_date}>
                    {getEventDateDisplay(event)}
                    {event.duration && `  ${event.duration}`} 開催
                  </span>
                </div>
                <span className={styles.rightContents_item_text_title}>{event.title.rendered}</span>
              </div>
            </a>
          </div>
        ))
      ) : (
        <p>現在開催中のイベントはありません</p>
      )}
    </div>
  )
}

export default ActiveEvent
